import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../../images/solution/it-staff/banner_it_staff.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service iphone_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                It Staff Augmentation Services
              </h1>
              <span style={{ color: "#000" }}>
                On-Demand, Skilled Staff Expansion
              </span>
              <p style={{ color: "#898989" }}>
                Scale your tech teams with our top-tier IT professionals and
                developers, bringing the specialized expertise you need to drive
                innovation and meet project demands.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Augment Your Tech Teams
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
